import { render, staticRenderFns } from "./yqg-header.vue?vue&type=template&id=6a960599&scoped=true&"
import script from "./yqg-header.js?vue&type=script&lang=js&"
export * from "./yqg-header.js?vue&type=script&lang=js&"
import style0 from "./yqg-header.scss?vue&type=style&index=0&id=6a960599&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a960599",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a960599')) {
      api.createRecord('6a960599', component.options)
    } else {
      api.reload('6a960599', component.options)
    }
    module.hot.accept("./yqg-header.vue?vue&type=template&id=6a960599&scoped=true&", function () {
      api.rerender('6a960599', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/kl-xiaodai/index/component/yqg-header/yqg-header.vue"
export default component.exports